<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6667 15.334L8.11998 17.661C6.86106 18.3054 5.90632 19.4202 5.52869 20.7831C4.89272 23.0783 4 26.7588 4 29.334M19.3333 15.334L23.88 17.661C25.1389 18.3054 26.0937 19.4202 26.4713 20.7831C27.1073 23.0783 28 26.7588 28 29.334"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M9.33203 29.334C9.33203 27.797 9.9987 22.6673 10.6672 21.334"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M10.668 22.6115C12.5825 22.9263 17.1295 22.0448 20.0013 16"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M16 26.6667C16 26.6667 22.6667 24 24 18"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M26.668 22C26.0615 24.9434 24.668 28 22.668 29.3333"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M20.6686 12.077L21.2293 9.20322C21.8891 5.8213 19.3657 2.66602 16.0013 2.66602C12.6369 2.66602 10.1135 5.8213 10.7733 9.20322L11.334 12.077C11.779 14.3577 13.7324 15.9993 16.0013 15.9993C18.2702 15.9993 20.2236 14.3577 20.6686 12.077Z"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M10.668 7.99935L14.7078 6.84761C15.5571 6.60548 16.4455 6.60548 17.2948 6.84761L21.3346 7.99935"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: number;
    color?: string;
  }>(),
  {
    size: 32,
    color: "#D0A444",
  },
);
</script>
